import { memo } from 'react';

import { FieldView } from './field-view';

export const Field = memo(FieldView);
Field.displayName = 'Field';
